"use strict";

module.exports = require('./lib/_stream_duplex.js');